import { createStore } from 'vuex'
import { _isMobile, _isApp } from '@/utils'
import modules from './modules'

export default createStore({
  namespaced: true,
  state: {
    isMobile: !!_isMobile(), // 判斷是否為H5
    isApp: !!_isApp(), // 判斷是否為APP
    animationPlayControl: {
      // 0: 未播放
      // 1: 可播放
      // 2: 播放完成 ( animationend )
      logoH5: 0,
      creditIcon: 0
    },
    versionControl: Math.random(),
    isApiReturnOnFirstLoad: false
  },
  getters: {
    isH5View(state) {
      return state.isMobile || state.isApp
    }
  },
  mutations: {
    setIsMobile(state, data) {
      state.isMobile = data
    },
    setIsApp(state, data) {
      state.isApp = data
    },
    setAnimationPlayControl(state, data) {
      state.animationPlayControl = { ...state.animationPlayControl, ...data }
    },
    setIsApiReturnOnFirstLoad(state, data) {
      state.isApiReturnOnFirstLoad = data
    },
    setVersionControl(state) {
      state.versionControl = Math.random()
    }
  },
  actions: {
    /**
     * 页面初次载入 所需加载的接口, 以及资料的处里
     * @returns Object
     */
    async firstLoadHandler({ commit, dispatch, state, rootState }) {
      const neededData = {
        isLogin: rootState.user.isLogin
      }
      if (neededData.isLogin === null) {
        await dispatch('user/getUserInfoV2', {}, { root: true })
        neededData.isLogin = rootState.user.isLogin
      }
      if (!state.isApiReturnOnFirstLoad)
        commit('setIsApiReturnOnFirstLoad', true)
      return neededData
    }
  },
  modules,
})
